/* ATA: mobile menu tap + current-page feedback (Oct 2026) */
(function () {
  function norm(p) { return (p.replace(/\/+$/, '') || '/').toLowerCase(); }

  function init() {
    var menu = document.getElementById('mobile-menu');
    if (!menu || menu.dataset.ataFeedback) return;
    menu.dataset.ataFeedback = '1';

    // Current page highlight
    var here = norm(location.pathname);
    menu.querySelectorAll('.mobile-menu a[href]').forEach(function (a) {
      var u;
      try { u = new URL(a.getAttribute('href'), location.origin); } catch (e) { return; }
      if (u.origin !== location.origin) return;
      var p = norm(u.pathname);
      if (p === '/' || p !== here) return;
      if (u.search && u.search !== location.search) return;
      a.classList.add('is-current');
      a.setAttribute('aria-current', 'page');
      var el = a.parentElement;
      while (el && el !== menu) {
        if (el.tagName === 'DETAILS') {
          var s = el.querySelector(':scope > summary');
          if (s) s.classList.add('is-current-parent');
        }
        el = el.parentElement;
      }
    });

    // Hold the tapped state until navigation completes
    menu.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank') return;
      menu.querySelectorAll('.is-tapped').forEach(function (x) { x.classList.remove('is-tapped'); });
      a.classList.add('is-tapped');
    });
  }

  // Clear the held state when returning via the back button (bfcache)
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('#mobile-menu .is-tapped').forEach(function (x) { x.classList.remove('is-tapped'); });
  });

  // iOS Safari only fires :active when a touch listener exists
  document.addEventListener('touchstart', function () {}, { passive: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();